import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Warehouses from "@/pages/Warehouses";
import Inward from "@/pages/Inward";
import PutAway from "@/pages/PutAway";
import Picking from "@/pages/Picking";
import Outward from "@/pages/Outward";
import Returns from "@/pages/Returns";
import GateRegister from "@/pages/GateRegister";
import Scan from "@/pages/Scan";
import Users from "@/pages/Users";
import Roles from "@/pages/Roles";
import AuditLogs from "@/pages/AuditLogs";
import Reports from "@/pages/Reports";
import Profile from "@/pages/Profile";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin mr-2" />Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={loading ? null : user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
      <Route path="/warehouses" element={<Protected><Warehouses /></Protected>} />
      <Route path="/inward" element={<Protected><Inward /></Protected>} />
      <Route path="/putaway" element={<Protected><PutAway /></Protected>} />
      <Route path="/picking" element={<Protected><Picking /></Protected>} />
      <Route path="/outward" element={<Protected><Outward /></Protected>} />
      <Route path="/returns" element={<Protected><Returns /></Protected>} />
      <Route path="/gate" element={<Protected><GateRegister /></Protected>} />
      <Route path="/scan" element={<Protected><Scan /></Protected>} />
      <Route path="/users" element={<Protected><Users /></Protected>} />
      <Route path="/roles" element={<Protected><Roles /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLogs /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
